import { render, staticRenderFns } from "./PdfAuditor.vue?vue&type=template&id=3fd58023&scoped=true&"
import script from "./PdfAuditor.vue?vue&type=script&lang=js&"
export * from "./PdfAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd58023",
  null
  
)

export default component.exports